export default class Timer {
    constructor(elem) {
        this.timerElem = elem;
        if (this.timerElem) {
            setInterval(this.setTime.bind(this), 1000);
        }
    }

    setTime() {
        const now = new Date();
        this.timerElem.innerHTML = now.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            timeZone: this.timerElem.dataset.timezone,
            hour12: false,
        });
        this.timerElem.setAttribute("datetime", now.toString());
    }
}
